import React, { useState, useEffect } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Paper, Typography, IconButton, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';

export const OverviewTopPerfomers = ({focusLocation, businessRevenue, freetier, topLineClass}) => {
    const [filteredBusiness, setFilteredBusiness] = useState([]);
    const [expandValue, setExpandValue] = useState(true);
    const [showHeatmapInfo, setShowHeatmapInfo] = useState(true);

    const numberWithCommas = (x) =>  {
        if(!x) return ''
        return '$' + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const handleBusinessChange = (businessRevenue) => {
        const filtered = businessRevenue
            .filter((e) => e.revenue)
            .sort((a, b) => (b?.revenue || 0) - (a?.revenue || 0))
            .slice(0, 20);

            setFilteredBusiness(filtered);
    }

    useEffect(() => {
        handleBusinessChange(businessRevenue);
    }, [businessRevenue]);


    const addOpacityToColor = (color, opacity = 0.05) => {
        // Check if the input is a string
        if (typeof color !== 'string') {
            return color;
          }
          
          // Regex to match RGB format: rgb(255, 0, 0) or rgb(255,0,0)
          const rgbRegex = /^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i;
          
          // Regex to match HEX format: #FFF or #FFFFFF
          const hexRegex = /^#([a-f\d]{3,4}|[a-f\d]{6}|[a-f\d]{8})$/i;
          
          // Check if the string matches RGB format
          const rgbMatch = color.match(rgbRegex);
          
          if (rgbMatch) {
            // Extract the RGB values
            const red = rgbMatch[1];
            const green = rgbMatch[2];
            const blue = rgbMatch[3];
            
            // Return RGBA with the specified opacity
            return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
          }
          
          // Check if the string matches HEX format
          const hexMatch = color.match(hexRegex);
          
          if (hexMatch) {
            let hex = hexMatch[1];
            
            // Convert shorthand hex (#FFF) to full form (#FFFFFF)
            if (hex.length === 3) {
              hex = hex.split('').map(char => char + char).join('');
            }
            
            // Parse the hex values to RGB
            const red = parseInt(hex.substring(0, 2), 16);
            const green = parseInt(hex.substring(2, 4), 16);
            const blue = parseInt(hex.substring(4, 6), 16);
            
            // Return RGBA with the specified opacity
            return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
          }
          
          // If it's not an RGB or HEX value, return the original
          return color;
      }
    const upgrade = ()=>{
        if(freetier)  window.location.href = "https://mapchise.com/contact/"
    }

    const HeatmapInfoPopup = () => (
        <Paper
            elevation={3}
            sx={{
                position: 'absolute',
                bottom: 0,
                right: 20,
                padding: '12px 16px',
                maxWidth: 280,
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(4px)',
                borderRadius: 2,
                border: '1px solid rgba(0, 0, 0, 0.1)',
                zIndex: 3,
                display: showHeatmapInfo ? 'block' : 'none'
            }}
        >
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                <InfoIcon 
                    sx={{ 
                        color: '#1976d2', 
                        fontSize: 18,
                        mt: 0.25,
                        flexShrink: 0
                    }} 
                />
                <div style={{ flex: 1 }}>
                    <Typography 
                        variant="body2" 
                        sx={{ 
                            fontSize: '0.8rem',
                            lineHeight: 1.4,
                            color: '#333',
                            fontWeight: 500
                        }}
                    >
                        This heatmap shows the approximate residential areas of store visitors, based on aggregated location data.
                    </Typography>
                </div>
                <IconButton
                    size="small"
                    onClick={() => setShowHeatmapInfo(false)}
                    sx={{
                        padding: '2px',
                        marginTop: '-4px',
                        marginRight: '-4px',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                        }
                    }}
                >
                    <CloseIcon sx={{ fontSize: 14 }} />
                </IconButton>
            </div>
        </Paper>
    );

    return (
        <div>
            <div className={topLineClass} >
                <div className='competitor-sidebar-main'>
                    <div className=''>
                        <Accordion 
                        key={'Customer Map'} 
                        expanded={expandValue} 
                        onChange={(e, isExpanded) => {setExpandValue(isExpanded)}}
                        sx={{ 
                            marginTop:'20px',
                            padding: '10px',
                            boxShadow: 'none',
                            border: 'none',
                            '&.MuiPaper-root': {
                            boxShadow: 'none',
                            border: 'none'
                            },
                            '&::before': {
                            display: 'none',
                            backgroundColor: 'transparent'
                            },
                            '& .MuiAccordion-root': {
                            boxShadow: 'none',
                            border: 'none'
                            },
                            '& .MuiAccordionSummary-root': {
                            padding: 0,
                            minHeight: 'auto'
                            },
                            '& .MuiAccordionDetails-root': {
                            padding: 0
                            }
                        }}
                        >
                        <AccordionSummary 
                            expandIcon={<ExpandMoreIcon />} 
                            aria-controls="panel1a-content" 
                            id="panel1a-header"
                            sx={{
                            flexDirection: 'row',
                            '& .MuiAccordionSummary-content': {
                                margin: 0
                            }
                            }}
                        >
                            <div className="font-weight600 data-component" style={{ 
                            }}>
                            Top Performing Locations
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            {filteredBusiness.map((location) => (
                                <div key={location._id} onClick={() => focusLocation(location)} className="total-locations-sidebar hover-color-grey-click" style={{backgroundColor: addOpacityToColor('rgb(79, 56, 240)')}}>
                                    <div>
                                    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M17.6201 7.45C16.5701 2.83 12.5401 0.75 9.0001 0.75C9.0001 0.75 9.0001 0.75 8.9901 0.75C5.4601 0.75 1.4201 2.82 0.370095 7.44C-0.799905 12.6 2.3601 16.97 5.2201 19.72C6.2801 20.74 7.6401 21.25 9.0001 21.25C10.3601 21.25 11.7201 20.74 12.7701 19.72C15.6301 16.97 18.7901 12.61 17.6201 7.45ZM9.0001 12.46C7.2601 12.46 5.8501 11.05 5.8501 9.31C5.8501 7.57 7.2601 6.16 9.0001 6.16C10.7401 6.16 12.1501 7.57 12.1501 9.31C12.1501 11.05 10.7401 12.46 9.0001 12.46Z"
                                            fill={'rgb(79, 56, 240)'}
                                        />
                                    </svg>
                                    </div>
                                    <div>
                                    <div className="name-locations-sidebar" style={{  color: 'rgb(79, 56, 240)' }}>{location.name}</div>
                                    <div className="address-locations-sidebar">{location.address}</div>
                                    </div>
                                    <div className="font-size-16 address-locations-sidebar ml-auto">{numberWithCommas(location?.revenue)}</div>
                                </div>
                            ))}
                        </AccordionDetails>
                        </Accordion>
                        </div>
            </div>
            {/* Map is now in the persistent location in LocationOverview.js */}

            
            </div>

    </div>
)
}